import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "wbo-cancel-button",
    styleUrls: ["./cancel-button.component.scss"],
    templateUrl: "cancel-button.component.html"
})
export class CancelButtonComponent {
    @Input() @HostBinding("class.disabled") disabled: boolean;
    @Input() public title: string;
}
